import { City } from './cities'
import { destinationEnum, getDestinationFromAPI } from './destination'
import { Theme } from './theme'

export function getMinIncludedCities(): number {
  return 3
}

export function getMaxIncludedCities(): number {
  return 50
}

export function filterDestination(
  includedCities: City[],
  theme: Theme,
  destination: destinationEnum,
  max?: number,
) {
  max = max || getMaxIncludedCities()
  if (
    ![destinationEnum.allOfEurope, destinationEnum.outsideEurope].includes(
      destination,
    )
  ) {
    const filtered = includedCities.filter(
      x => getDestinationFromAPI(x.direction) === destination,
    )
    const notFiltered = includedCities.filter(
      x => getDestinationFromAPI(x.direction) !== destination,
    )
    if (includedCities.length > 0 && filtered.length < max) {
      return filtered.concat(notFiltered.slice(0, max - filtered.length))
    } else {
      return filtered.slice(0, max)
    }
  }
  return includedCities
}
